$(".flavourOne-close").click(function () {
  $(".flavourOne-overlay").hide();
});

$(".flavour_one .pin1").click(function () {
  $(".flavourOne-overlay.flavour_one").show();
  $(".flavourTwo-overlay.flavour_one").hide();
  $(".flavourOne-overlay.flavour_two").hide();
  $(".flavourTwo-overlay.flavour_two").hide();
});

$(".flavour_one .pin2").click(function () {
  $(".flavourOne-overlay.flavour_one").hide();
  $(".flavourTwo-overlay.flavour_one").show();
  $(".flavourOne-overlay.flavour_two").hide();
  $(".flavourTwo-overlay.flavour_two").hide();
});

$(".flavourTwo-close").click(function () {
  $(".flavourTwo-overlay").hide();
});

$(".flavour_two .pin1").click(function () {
  $(".flavourOne-overlay.flavour_one").hide();
  $(".flavourTwo-overlay.flavour_one").hide();
  $(".flavourOne-overlay.flavour_two").show();
  $(".flavourTwo-overlay.flavour_two").hide();
});

$(".flavour_two .pin2").click(function () {
  $(".flavourOne-overlay.flavour_one").hide();
  $(".flavourTwo-overlay.flavour_one").hide();
  $(".flavourOne-overlay.flavour_two").hide();
  $(".flavourTwo-overlay.flavour_two").show();
});
